<ng-template #packingListNumberTemp let-row="row">
  {{row?.packingListNumber || row?.id}}
</ng-template>
<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card
        [advanceButton]="true"
        (outputButtonAdvance)="callFunction($event)"
        [advancedButtons]="specialButtons"
        [cardOptionBtnValue]="'menu.credit-invoice.view'|translate"
        [title]="'global.overview'|translate">
        <app-grid [grid]="grid"></app-grid>
      </app-card>
    </div>
  </div>
</div>
<a #downloadLink href="" download style="display: none"></a>
<app-generate-packaging-label #generateModal="generatePackagingLabel"
  [packagingLabel]="packagingLabel"
  ($resultPL)="refreshGid($event)"
>
</app-generate-packaging-label>
